import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import BuildingSearchResult from "../../components/search/BuildingSearchResult";
import CategorySearchResult from "../../components/search/CategorySearchResult";
import MapSearch from "../../components/search/MapSearch";
import PoiSearchResult from "../../components/search/PoiSearchResult";
import { useEnableMapLocationClick } from "../../hooks/useEnableMapLocationClick";

const Search = () => {
  const { type, id } = useParams<{ type: string; id: string }>();
  useEnableMapLocationClick();

  if (!type || !id) return <MapSearch />;

  return (
    <>
      <MapSearch />
      {type === "category" ? (
        <CategorySearchResult id={id} />
      ) : type === "building" ? (
        <BuildingSearchResult id={id} />
      ) : type === "poi" ? (
        <PoiSearchResult id={id} />
      ) : null}
    </>
  );
};

export default Search;
